import { Component, EventEmitter, HostListener, inject, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ServiceDetailCaptureTableModel } from 'src/app/models/rental/service-detail-capture-table.model';
import { ServiceDetailModel } from 'src/app/models/rental/service-detail.model';
import { ServiceModel } from 'src/app/models/rental/service.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { OrderDetailSelectionTableModel } from 'src/app/models/tables/preliminaries/order-detail-selection-table.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ConceptInvoicingService } from 'src/app/services/invoicing/concept-invoicing.service';
import { ServiceDetailService } from 'src/app/services/rental/service-detail.service';
import { ServiceService } from 'src/app/services/rental/service.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterCostCenterPriceComponent } from 'src/app/views/archive/cost-center-price/register-cost-center-price/register-cost-center-price.component';
import { ServiceManualOrderComponent } from '../service-manual-order/service-manual-order.component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-service-detail',
  templateUrl: './service-detail.component.html',
  styleUrls: ['./service-detail.component.scss'],
  standalone: false
})
export class ServiceDetailComponent implements OnInit {

  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly conceptInvoicingService = inject(ConceptInvoicingService);
  private readonly serviceDetailService = inject(ServiceDetailService);
  private readonly serviceService = inject(ServiceService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterPriceRegisterModal') costCenterPriceRegisterComponent?: CustomModalComponent | null = null;
  @ViewChild('serviceManualOrderSelection') serviceManualOrderSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() defaultStoreIdForBranch: number | null = null;
  @Input() disabledDetail: boolean = false;
  @Input() formService: FormGroup | null = null;
  @Input() isCreatingServiceFromOrder: boolean = false;
  @Input() permissionUpdatable: boolean = false;
  @Input() permissionsUser: OptionWindowModel[] = [];
  @Input() quantityDetails: number = 0;
  @Input() serviceModel: ServiceModel = new ServiceModel();
  @Input() swServiceRequiresOrder: boolean = false;
  @Input() swfacturacionEspecial: boolean = false;
  @Input() userAuthenticated: UserModel = new UserModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() serviceContract = new EventEmitter<ServiceModel>();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    { label: 'Eliminar', icon: 'pi pi-trash', color: ActionColor.DANGER, action: 'bulk-delete' },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentManualOrderSelection = ServiceManualOrderComponent;
  componentRegisterModal = RegisterCostCenterPriceComponent;
  componentTableSelection = CustomTableSelectComponent;
  conceptInvoicingIdAlquiler: number = 0;
  costCenterPriceContract: CostCenterPriceModel = new CostCenterPriceModel();
  dataArticle: PagedResponseModel<ArticleSelectionTableModel> = new PagedResponseModel<ArticleSelectionTableModel>();
  detailData: PagedResponseModel<ServiceDetailCaptureTableModel> = new PagedResponseModel<ServiceDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [], data: [], showCheckbox: false, showRecover: true, isMultipleSelect: true, filters: [], actions: []
  });
  inputsForRegisterModals$ = new BehaviorSubject<any>({
    blockForm: false, costCenterPriceModel: new CostCenterPriceModel(), openFrom: ''
  });
  inputsForServiceManualOrderSelectionModals$ = new BehaviorSubject<any>({
    branchId: 0, orderId: 0,
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  openCostCenterPriceRegister: boolean = false;
  openFromCostCenterPrice: string = "editServiceDetail";
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  serviceDetail: ServiceDetailModel = new ServiceDetailModel();
  subscription!: Subscription;
  tableActions: TableAction[] = [];

  async ngOnInit() {
    await Promise.all([
      this.getColumnsForCaptureTable(),
      this.getConceptInvoicingAlquiler()
    ]);
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    const serviceModel = changes["serviceModel"];
    const disabledDetail = changes["disabledDetail"];
    const isCreatingServiceFromOrder = changes["isCreatingServiceFromOrder"];
    if (serviceModel && !serviceModel.firstChange) {
      await this.getServiceDetailsByService();
      this.clearSelectionTrigger++;
      this.getFormView(false);
    };
    if (disabledDetail) {
      this.tableActions = this.disabledDetail ? [] : this.getDefaultActions();
    };
    if (isCreatingServiceFromOrder && !isCreatingServiceFromOrder.firstChange) {
      this.openServiceManualOrderSelectionModal('header');
    };
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async deleteServiceDetail(selectedIds: number[]) {
    if (!selectedIds || selectedIds.length === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar al menos un registro para eliminar.'
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar los detalles seleccionados?');
    if (accepted) {
      try {
        await firstValueFrom(this.serviceDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast(
          'success',
          'El detalle del servicio fue eliminado exitosamente.'
        );
        await this.getServiceDetailsByService();
        this.clearSelectionTrigger++;
        this.getFormView(false);
      } catch (error) {
        console.error('Error al eliminar los detalles del servicio:', error);
      }
    }
  }

  async getArticlesForServiceDetail() {
    try {
      const response = await firstValueFrom(this.serviceDetailService.getArticlesForDetailsAsync(
        this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle
      ));
      this.dataArticle = response;
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getConceptInvoicingAlquiler() {
    try {
      const response = await firstValueFrom(this.conceptInvoicingService.getConceptInvoicingAlquiler());
      this.conceptInvoicingIdAlquiler = response.conceptInvoicingId;
    } catch (error) {
      console.error('Error al obtener el consepto de alquiler.', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length === 0) {
        const response = await firstValueFrom(this.serviceDetailService.getColumnsForArticles());
        this.headerArticle = response;
        this.updateInputs();
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getColumnsForCaptureTable() {
    try {
      if (this.detailHeader.length === 0) {
        const response = await firstValueFrom(this.serviceDetailService.getColumnsForCaptureTable());
        this.detailHeader = response;
      }
    } catch (error) {
      console.error('Error searching columns for query.', error);
    }
  }

  async getCostCenterPriceRegister(costCenterPrice: CostCenterPriceModel) {
    if (costCenterPrice.costCenterPriceId != 0) {
      await this.getServiceDetailsByService();
      this.getFormView(false);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      },
      {
        label: 'Editar Precios C.Costos',
        icon: 'pi pi-dollar',
        action: 'prices-cost-center',
      },
    ];
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getServiceDetailById(serviceDetailId: number) {
    try {
      return await firstValueFrom(this.serviceDetailService.getServiceDetailById(serviceDetailId));
    } catch (error) {
      console.error("Error fetching service detail by ID.", error);
      return null;
    }
  }

  async getServiceDetailsByService() {
    try {
      this.detailData = await firstValueFrom(this.serviceDetailService.getServiceDetailsForCaptureTable(
        this.page, this.limit, this.columnSort, this.ascendant, this.serviceModel.serviceId
      ));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error searching details services.', error);
    }
  }

  async getServiceDetailByKeys(articleId: number) {
    const serviceId = this.serviceModel.serviceId;
    try {
      const response = await firstValueFrom(this.serviceDetailService.getServiceDetailByKeys(serviceId, articleId));
      this.serviceDetail = response;
      this.getFormView(true);
    } catch (error) {
      console.error('Error a obtener el detalle del servicio.', error);
    }
  }

  async handleServiceManualOrderSelection(selectedItems: OrderDetailSelectionTableModel[]) {
    const [selectedItem]: OrderDetailSelectionTableModel[] = selectedItems;
    const serviceId = this.serviceModel.serviceId || 0;
    const currentOrderId = this.serviceModel.orderId || 0;
    if (serviceId <= 0 || currentOrderId !== selectedItem.orderId) {
      await this.saveServiceByOrder(selectedItem.orderDetailId);
    }
    if (this.serviceModel.serviceId > 0) {
      await this.getServiceDetailByKeys(selectedItem.articleId);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const [selected] = selectedItem;
    const articleId = selected?.articleId;
    this.serviceDetail = new ServiceDetailModel();
    this.serviceDetail.articleId = articleId;
    this.getFormView(true);
  }

  async onAction(event: { action: string, item?: ServiceDetailCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await this.getServiceDetailById(event.item!.id);
      if (response)
        this.serviceDetail = response;
      this.getFormView(true);
    }
    if (event.action === 'prices-cost-center') {
      if (this.swfacturacionEspecial) {
        this.toastHandlerService.showToast(
          'warning',
          `No puede modificar precios por centro de costos. La compañía cuenta con la configuración "Facturación Especial".`
        );
        return;
      }
      if (this.swServiceRequiresOrder && this.serviceModel?.swOrder && (this.serviceModel?.orderId ?? 0) > 0) {
        this.toastHandlerService.showToast(
          'warning',
          'No puede modificar precios por centro de costos. El servicio tiene un pedido vinculado.'
        );
        return;
      }
      const serviceDetail = await this.getServiceDetailById(event.item!.id);
      if (!serviceDetail) { return; }
      this.costCenterPriceContract = new CostCenterPriceModel();
      this.costCenterPriceContract.costCenterId = serviceDetail.costCenterPrice.costCenterId;
      this.costCenterPriceContract.conceptInvoicingId = this.conceptInvoicingIdAlquiler;
      this.costCenterPriceContract.articleId = serviceDetail.costCenterPrice.articleId;
      this.openCostCenterPriceRegisterModal();
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      await this.deleteServiceDetail(event.selectedItems);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getServiceDetailsByService();
    this.getFormView(false);
  }

  async onPageChangeArticle(event: { page: number; pageSize: number; sortField: string | undefined; sortOrder: number; }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getArticlesForServiceDetail();
  }

  async openArticleSelectionModal() {
    if (!this.serviceModel.serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un Servicio.'
      );
      return;
    }
    if (this.serviceModel?.serviceId) {
      const { swOrder, orderId } = this.formService!.getRawValue();
      const isSwOrderChanged = swOrder !== this.serviceModel?.swOrder;
      const isOrderIdChanged = orderId !== this.serviceModel?.orderId;
      if (isSwOrderChanged || isOrderIdChanged) {
        this.toastHandlerService.showToast(
          'warning',
          'Guarde los cambios del encabezado para continuar.'
        );
        return;
      }
    }

    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForServiceDetail(),
    ]);
    this.articleSelectionModalComponent?.show()
  }

  openCostCenterPriceRegisterModal() {
    this.inputsForRegisterModals$.next({
      blockForm: false,
      costCenterPriceModel: this.costCenterPriceContract,
      openFrom: this.openFromCostCenterPrice
    });
    this.costCenterPriceRegisterComponent?.show();
  }

  openServiceManualOrderSelectionModal(origin: 'header' | 'detail') {
    if (!this.formService) return;
    const { swOrder, orderId } = this.formService.getRawValue();
    if (this.serviceModel?.serviceId) {
      const isSwOrderChanged = swOrder !== this.serviceModel?.swOrder;
      const isOrderIdChanged = orderId !== this.serviceModel?.orderId;
      if (isSwOrderChanged || isOrderIdChanged) {
        this.toastHandlerService.showToast(
          'warning',
          'Guarde los cambios del encabezado para continuar.'
        );
        return;
      }
    }
    if (!swOrder) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe habilitar la opción “Req. Pedido” para ingresar a la selección.'
      );
      return;
    }
    const orderIdToSelection = origin === 'header' ? 0 : (this.serviceModel?.orderId ?? 0);
    this.inputsForServiceManualOrderSelectionModals$.next({
      orderId: orderIdToSelection,
      branchId: this.serviceModel?.branchId ?? 0
    });
    this.serviceManualOrderSelectionModalComponent?.show();
  }

  processFilter(filter: any) {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter((f) => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find((f) => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) => index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async saveServiceByOrder(orderDetailId: number) {
    try {
      const serviceId = this.serviceModel.serviceId;
      const response = await firstValueFrom(this.serviceService.saveServiceByOrder(orderDetailId, serviceId));
      this.serviceModel = response;
      this.serviceContract.emit(response);
      if (serviceId > 0) {
        this.toastHandlerService.showToast(
          'success',
          'El servicio fue actualizado exitosamente.'
        );
      } else {
        this.toastHandlerService.showToast(
          'success',
          'El servicio fue creado exitosamente.'
        );
      }
    } catch (error) {
      console.error('Error al procesar el servicio.', error);
    }
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }
}
